import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { yearsEmployed } from '../../../constants/formFields/yearsEmployed';
import { stillEmployed } from '../../../constants/formFields/stillEmployed';

export const StepTwo = (errors) => (
  <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step2">
    <div className="mb-6 form-radio2-main">
      <label htmlFor="still-employed" className="block text-gray-700 font-medium mb-2">
        Are you still employed? <span>*</span>
      </label>
      <div className="space-y-2">
        {stillEmployed.map((ele, i) => {
          const id = `still_employed_${i}`;
          return (
            <div className="flex items-center form-radio2" key={i}>
              <Field
                type="radio"
                id={id}
                name="still-employed"
                value={ele.value}
                className="mr-2"
              />
              <label htmlFor={id}>{ele.value === 'E' ? ele.label : 'No (' + ele.label + ')'}</label>
            </div>
          );
        })}
        <ErrorMessage name="still-employed" component="div" className="required-text" />
      </div>
    </div>

    <div className="mb-6 form-radio2-main">
      <label className="block text-gray-700 font-medium mb-2">
        Years employed <span>*</span>
      </label>
      <div className="space-y-2">
        {yearsEmployed.map((ele, i) => {
          const id = `years_employed_${i}`;
          return (
            <div className="flex items-center form-radio2" key={i}>
              <Field
                type="radio"
                id={id}
                name="years-employed"
                value={ele.value}
                className="mr-2"
              />
              <label htmlFor={id}>{ele.label}</label>
            </div>
          );
        })}
        <ErrorMessage name="years-employed" component="div" className="required-text" />
      </div>
    </div>
  </div>
);

export default StepTwo;
